import {useNavigate, useParams} from 'react-router-dom';
import DotsLoading from '../../../components/dotsLoading';
import HeaderBasketButton from '../../../components/headerBasketButton';
import CustomSearchBox from '../../../components/mazraeKit/customSearchBox';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import NoSearchResult from '../../../components/mazraeKit/noSearchResult';
import PageLoader from '../../../components/pageLoader';
import {
  getInputGroupCode,
  getNameByInputGroup,
} from '../../../module/dashboard/category/utilities';
import {IGetListSubBrandPayload} from '../../../services/hookService/products/useGetListSubBrand/types';
import useGetListSubBrand from '../../../services/hookService/products/useGetListSubBrand/useGetListSubBrand';
import useDebouncedQueryParam from '../../../utilities/hooks/useDebouncedQueryParam/useDebouncedQueryParam';
import ProductItemCard from './ProductItemCard';
import MainFooter from '../../../components/mazraeKit/footers/footerMain/index';

const ProductsPage = () => {
  const navigate = useNavigate();
  const {inputGroupName} = useParams<{inputGroupName: string}>();

  const headerTitle =
    getNameByInputGroup[inputGroupName as string] || 'محصولات';

  // Single hook replaces all manual URL management
  const [search, setSearch, {debounced: debouncedSearch, flush}] =
    useDebouncedQueryParam('search', '', 1000);

  // Use debounced value for API calls
  const payload: IGetListSubBrandPayload = {
    inputGroupCode: getInputGroupCode[inputGroupName as string],
    ...(Boolean(debouncedSearch) && {search: debouncedSearch}),
  };

  const {data, isLoading, isFetchingNextPage, loaderRef} =
    useGetListSubBrand(payload);

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      <CustomHeader
        isActiveRightIcon={true}
        preComponent={() => (
          <div
            className="flex relative gap-2 justify-center items-center"
            onClick={() => navigate('/home')}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">{headerTitle}</span>
          </div>
        )}
        postComponent={() => <HeaderBasketButton />}
      />

      <div className="sticky top-0 z-10 p-3">
        <CustomSearchBox
          placeholder={`جستجو در ${headerTitle}`}
          type="text"
          inputValue={search}
          onChange={e => setSearch(e.target.value)}
          onBlur={flush}
          inputCustomClass="!pr-2"
          removeIcon="icon-nameClose-remove"
          preIcon="icon-nameSearch"
          setInputValue={() => setSearch('')}
        />
      </div>

      {/* Page Content */}
      <div className="flex overflow-y-auto flex-col gap-3 p-3 w-full h-full">
        {isLoading && <PageLoader />}

        {!isLoading && data?.length === 0 && <NoSearchResult />}

        <div className="grid grid-cols-2 gap-3">
          {!isLoading &&
            data?.map((item, index) => (
              <div
                key={`${index} - ${item?.sub_brand_guid}`}
                onClick={() =>
                  navigate(
                    `/product-shop-list/${inputGroupName}/${item?.sub_brand_guid}/${item?.quantity_pack}/${item.quantity_pack_unit}`,
                  )
                }
              >
                <ProductItemCard
                  item={item}
                  inputGroupCode={payload?.inputGroupCode}
                />
              </div>
            ))}
        </div>

        {/* Infinite scroll sentinel */}
        <div ref={loaderRef} className="mt-4 text-center">
          {isFetchingNextPage ? <DotsLoading /> : null}
        </div>
      </div>
      <MainFooter />
    </div>
  );
};

export default ProductsPage;
